/**
 * Turns a *Promise&lt;void&gt;* into a *Promise&lt;boolean&gt;* that returns *false* on successful completion.
 *
 * This is needed in some cases for actions. Such as when we don't want the normal dispatchAction to be called, as
 * is the case for address lookup functionality.
 *
 * See the *createActionPromises* function for detail.
 */
export function promiseVoidToFalse(promiseVoid: Promise<void>): Promise<boolean> {
  return new Promise<boolean>((resolve, reject) => {
    promiseVoid
      .then(() => {
        resolve(false);
      })
      .catch(reject);
  });
}
